export default function Wand() {
  return (
    <div
      className="ion-icon-wand"
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve">
<g>
	
		<rect x="238.059" y="206.059" transform="matrix(0.7071 0.7071 -0.7071 0.7071 249.3726 -122.0387)" width="67.882" height="67.882"/>
	
		<rect x="110.058" y="243.549" transform="matrix(0.7071 0.7071 -0.7071 0.7071 302.3989 5.9646)" width="67.884" height="248.901"/>
	<rect x="256" y="32" width="32" height="64"/>
	<rect x="380.451" y="83.55" transform="matrix(-0.7071 -0.7071 0.7071 -0.7071 595.0701 477.5923)" width="32" height="63.999"/>
	<rect x="131.549" y="83.549" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -38.4898 138.1746)" width="32" height="64"/>
	<rect x="380.451" y="332.451" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -141.5881 387.0668)" width="32" height="64"/>
	<rect x="416" y="224" width="64" height="32"/>
</g>
</svg>
`,
      }}
    />
  )
}
